import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 121,
  label: "代理机构代理量分析",
  chart: charts.lineAndBar,
  definition: {
    rowDims: [{
      name: "agencyName",
      label: "代理机构",
      limit: 10,
      needTotal: true
    }],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
    condition: {
      items: [{
        name: "agencyName",
        operator: "NOT_NULL"
      }]
    }
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "代理机构代理量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false
  }
};
